import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const LargeEquipment = createSvgIcon(
  <path d="M0 1.5h12.75v2.25H9.412L10.5 5.708V7.5h.674l6.076 3.472v.278h2.25v-.75h3.75v2.25h-1.5v4.5A2.25 2.25 0 0 0 24 19.5v2.25a4.5 4.5 0 0 1-4.5-4.5V13.5h-2.25v2.25l-.54.72a3.375 3.375 0 1 1-5.423 3.154h-3.89A3.752 3.752 0 0 1 0 18.751c0-.969.367-1.852.97-2.517L0 15.02V7.5h1.5V3.75H0V1.5Zm7.24 15.875h4.499a3.374 3.374 0 0 1 2.694-1.62L15 15v-2.722L10.576 9.75H2.25v4.48l.686.858a3.751 3.751 0 0 1 4.303 2.287ZM3.75 3.75V7.5h4.5V6.292L6.838 3.75H3.75Z" />,
  'LargeEquipment'
);

export { LargeEquipment };